export default function MobileContactBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      {/* Erreichbarkeit-Hinweis */}
      <div className="bg-[#1A1A1A]/95 backdrop-blur-sm px-4 py-1.5 flex items-center justify-center gap-1.5">
        <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse flex-shrink-0"></span>
        <span className="text-white/60 text-xs">Mo–Fr 10–15 Uhr · Sa 12–15 Uhr · Notdienst 24/7</span>
      </div>

      {/* Action Buttons */}
      <div className="bg-white border-t border-gray-100 px-4 py-3 flex gap-3">
        <a
          href="tel:+492102739807"
          className="flex-1 flex items-center justify-center gap-2 bg-black text-white font-semibold text-sm py-3.5 rounded-xl cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-fill text-base"></i>
          Jetzt anrufen
        </a>
        <a
          href="https://wa.me/4901722474064"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold text-sm py-3.5 rounded-xl cursor-pointer whitespace-nowrap"
        >
          <i className="ri-whatsapp-line text-base"></i>
          WhatsApp
        </a>
      </div>
    </div>
  );
}
